import React from 'react';

const CRMContext = React.createContext();

/* Prevent circular dependencies - webpack messes up the context api otherwise */
export default CRMContext;
